import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=0e0a5426"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=0e0a5426&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0a5426')) {
      api.createRecord('0e0a5426', component.options)
    } else {
      api.reload('0e0a5426', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=0e0a5426", function () {
      api.rerender('0e0a5426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Profile.vue"
export default component.exports